export const locale = {
    lang: 'fr',
    data: {
        view: {}
    }
};
